import * as Turbo from "@hotwired/turbo"
import {ApiReturnType} from "@root/server/client/esweb/src/lib/ApiTypes.ts";


// const commandHandlers = {
    // visit: ({url, ...rest}) => {
    //     Turbo.visit(url, rest);
    // }
// }


export async function fetchApi<T>(url: string, init?: RequestInit): Promise<ApiReturnType<T> | null> {

    let _init = init ?? {};
    const method = (_init.method ?? 'get').toLowerCase();

    _init.headers = {
        "accept": "application/json",
        "x-csrf-token": window.clientConfig.CSRF_TOKEN,
        ..._init.headers,
    }

    const response = await fetch(url, init);

    if (method !== 'get') {
        Turbo.cache.exemptPageFromCache();
    }

    const contentType = response.headers.get("content-type");

    if (contentType?.includes("application/json")) {
        const json: ApiReturnType<T>= await response.json();

        if(json.visit) {
            const {url, ...rest} = json.visit;
            Turbo.visit(url, rest);
            return null;
        }

        if (json.error) {
            throw new Error(json.error);
        }

        // if(json.commands) {
        //     for (const command of json.commands) {
        //         const handler = commandHandlers[command.id];
        //         if(!handler) {
        //             console.error('Unmatched command', command);
        //             continue;
        //         }
        //         await handler(command.params);
        //     }
        // }

        return json;
    }

    const text = await response.text();
    if (contentType?.includes("text/vnd.turbo-stream.html")) {
        Turbo.renderStreamMessage(text);
        return null;
    }

    throw new Error(text);
}